import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNights = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.524 6.62.49-.102a.5.5 0 0 0-.973-.027l.483.13ZM9.379 1.477l.13.483a.5.5 0 0 0-.027-.972l-.103.49ZM14.167 8A6.167 6.167 0 0 1 8 14.167v1A7.167 7.167 0 0 0 15.167 8h-1Zm-.132-1.276c.086.411.132.838.132 1.276h1c0-.508-.053-1.004-.154-1.482l-.978.206Zm.006-.233a3.7 3.7 0 0 1-3.572 2.737v1a4.7 4.7 0 0 0 4.538-3.478l-.966-.259Zm-3.572 2.737a3.698 3.698 0 0 1-3.697-3.697h-1a4.698 4.698 0 0 0 4.697 4.697v-1ZM6.772 5.531a3.7 3.7 0 0 1 2.737-3.572L9.25.993a4.7 4.7 0 0 0-3.478 4.538h1ZM8 1.833c.438 0 .865.046 1.277.132l.205-.978A7.194 7.194 0 0 0 8 .833v1ZM1.833 8A6.167 6.167 0 0 1 8 1.833v-1A7.167 7.167 0 0 0 .833 8h1ZM8 14.167A6.167 6.167 0 0 1 1.833 8h-1A7.167 7.167 0 0 0 8 15.167v-1Z"
      fill="#17181A"
    />
  </svg>
);
const Memo = memo(SvgNights);
export default Memo;
